import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../Navbar'
import PageTitle from '../pagetitle'
import BookingForm from '../BookingForm'
import Footer from '../footer'
import Scrollbar from '../scrollbar'
import quranImg from '../../images/service/service/Basic Qaida.webp'
import quranLearning from '../../images/service/service-sub-pages/Basic Qaida.jpg'
import banner1 from '../../images/banners/1.webp'
import './style.css'

const BasicQaida = () => {
    const ClickHandler = (e) => {
        const hash = e.currentTarget.hash;
        if (hash === '#booking-form') {
            e.preventDefault();
            const element = document.getElementById('booking-form');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            window.scrollTo(10, 0);
        }
    }

    return (
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={'Basic Qaida'} pagesub={'Service'} backgroundImage={banner1} hideText={true}/>
            <section className="service-single-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-8 col-md-12 col-12">
                            <div className="service-single-content">
                                <div className="service-single-img">
                                    <img src={quranImg} alt="Basic Qaida - Beginner Quran Reading"/>
                                </div>
                                <h2 className="service-title"> <span>Basic Qaida</span> <br/> (Beginner Quran Reading)</h2>
                                <div className="service-description">
                                    <p>Begin your journey to reading the Quran with confidence through our comprehensive Basic Qaida course. This foundational program is designed for absolute beginners who want to learn the Arabic alphabet and develop essential reading skills. We've structured this course to make learning enjoyable and effective for students of all ages.</p>
                                </div>
                                
                                <div className="service-single-inner">
                                    <span><img src={quranLearning} alt="Children learning Quran"/></span>
                                    <div className="service-single-tb-text">
                                        <h3 className="service-section-title"><i className="fi flaticon-book"></i> Course Content</h3>
                                        <ul className="service-features-list">
                                            <li>Alphabet pronunciation - mastering Arabic letters and sounds</li>
                                            <li>Reading with Tajweed - foundation of proper recitation</li>
                                            <li>Pillars of Islam - understanding the five core principles</li>
                                            <li>Method of Wudu or ablution - learning proper ritual purification</li>
                                            <li>Namaz or Prayers - how to perform the five daily prayers</li>
                                            <li>Duas or supplications - memorizing essential Islamic prayers</li>
                                            <li>Basic Islamic Knowledge - fundamental concepts and teachings</li>
                                            <li>99 names of Allah - learning the beautiful attributes of God</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-teacher"></i> Course Format</h3>
                                    <div className="service-section-content">
                                        <p>Our Basic Qaida course is available in both one-to-one and small group settings (maximum 4 students) via online video platforms. We use interactive teaching methods with visual aids, digital Qaida books, and engaging activities to keep students motivated throughout their learning journey.</p>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-calendar"></i> Flexible Schedule</h3>
                                    <div className="service-section-content">
                                        <p>We understand that students have different commitments, which is why we offer flexible scheduling options:</p>
                                        <ul className="service-features-list">
                                            <li>Weekly classes</li>
                                            <li>Mutiple Sessions</li>
                                            <li>Personalized schedules to accommodate school and work commitments</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-money-bag"></i> Course Fees</h3>
                                    <div className="service-section-content">
                                        <div className="pricing-table">
                                            <div className="pricing-option">
                                                <h4>3 Days per Week</h4>
                                                <div className="price">£30<span>/month</span></div>
                                                <p>Ideal for beginners seeking a balanced pace</p>
                                            </div>
                                            <div className="pricing-option featured">
                                                <h4>4 Days per Week</h4>
                                                <div className="price">£40<span>/month</span></div>
                                                <p>Most popular option for steady progress</p>
                                            </div>
                                            <div className="pricing-option">
                                                <h4>5 Days per Week</h4>
                                                <div className="price">£50<span>/month</span></div>
                                                <p>Accelerated learning for dedicated students</p>
                                            </div>
                                        </div>
                                        <p className="pricing-note">All packages include personalized attention, learning materials, and regular progress assessments. Family discounts available for multiple enrollments.</p>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-lotus"></i> Benefits of Our Basic Qaida Course</h3>
                                    <div className="service-section-content">
                                        <ul className="service-features-list">
                                            <li>Builds strong reading foundation for lifelong Quranic study</li>
                                            <li>Child-friendly teaching methods with colorful materials and interactive exercises</li>
                                            <li>Regular progress assessments to ensure understanding</li>
                                            <li>Perfect preparation for advancing to Tajweed courses</li>
                                            <li>Supportive learning environment with patient, experienced tutors</li>
                                            <li>Digital resources for practice between classes</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-conclusion">
                                    <p>Our Basic Qaida course is the perfect starting point for anyone looking to embark on their Quranic journey. With our structured approach and experienced tutors, students will develop confidence in recognizing and pronouncing Arabic letters correctly, setting a solid foundation for further Quranic studies.</p>
                                </div>
                                
                                <div className="btns text-center mt-5">
                                    <Link onClick={ClickHandler} to="/home#booking-form" className="theme-btn">Book a Free Trial Class</Link>
                                </div>
                            </div>
                            
                            <div className="prv-nx">
                                <div className="pre-btn"><Link onClick={ClickHandler} to="/assessments">Previous: Assessments & Certification</Link></div>
                                <div className="nex-btn"><Link onClick={ClickHandler} to="/tajweed">Next: Tajweed (Quran Recitation Rules)</Link></div>
                            </div>
                        </div>
                        
                        <div className="col col-lg-4 col-md-12 col-12">
                            <div className="service-sidebar">
                                <div className="widget service-list-widget">
                                    <h3>All Services</h3>
                                    <ul>
                                        <li className="current"><Link to="/basic-qaida">Basic Qaida (Beginner Quran Reading)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/tajweed">Tajweed (Quran Recitation Rules)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/tajweed-improvement">Tajweed Improvement (Advanced)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/hifz">Hifz (Quran Memorisation)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/class-options">Class Options</Link></li>
                                        <li><Link onClick={ClickHandler} to="/free-demo">Free Demo Class</Link></li>
                                        <li><Link onClick={ClickHandler} to="/assessments">Assessments & Certification</Link></li>
                                    </ul>
                                </div>
                                <div className="widget contact-widget">
                                    <div>
                                        <h4>Book Your Free Trial Class</h4>
                                        <h2><a href="https://wa.me/message/UTB4XLJQLZ22M1">+44 784 035 7821</a></h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BookingForm/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
}

export default BasicQaida; 